<template>
  <div id="xxgs">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="title">信息公示</div>
      </div>
    </header>
    <div class="tab">
      <router-link v-for="(item,key,index) in xxgstitle" v-if="IsFirstTab===Math.floor(index/4)"
                   :to="{ name: 'xxgs', params: { nr: key }}" :key="key"
                   :class="{ active: $route.params.nr===key }">{{item}}
      </router-link>
      <span class="icon" @click="showOthers=true" v-show="!showOthers"><i class="am-icon-chevron-down"></i></span>
      <span class="icon" @click="showOthers=false" v-show="showOthers"><i class="am-icon-chevron-up"></i></span>
    </div>
    <div class="tab" v-show="showOthers">
      <router-link v-for="(item,key,index) in xxgstitle" v-if="IsFirstTab!==Math.floor(index/4)"
                   :to="{ name: 'xxgs', params: { nr: key }}" :key="key">{{item}}
      </router-link>
    </div>
    <div :class="{ zz: showOthers }">
      <div class="zzc"></div>
      <component :is="$route.params.nr" class="wrapper min-height"></component>
    </div>
    <ICP></ICP>
  </div>
</template>

<script>
  import OffCanvas from '@/components/OffCanvas/OffCanvas'
  import ICP from '@/components/ICP/ICP'
  import title from '@/common/title/title'

  import gsxx from '@/page/xxgs/nr/gsxx'
  import glry from '@/page/xxgs/nr/glry'
  import cyry from '@/page/xxgs/nr/cyry'
  import cwxx from '@/page/xxgs/nr/cwxx'
  import gdxx from '@/page/xxgs/nr/gdxx'
  import lsqk from '@/page/xxgs/nr/lsqk'
  import fzjg from '@/page/xxgs/nr/fzjg'
  import cxjl from '@/page/xxgs/nr/cxjl'
  import zgs from '@/page/xxgs/nr/zgs'
  import qtgs from '@/page/xxgs/nr/qtgs'

  export default {
    name: 'xxgs',
    data () {
      return {
        showOthers: false,
        xxgstitle: title.xxgstitle,
        currentView: this.$route.params.nr
      }
    },
    computed: {
      IsFirstTab: function () {
        let i = 0
        for (let item in this.xxgstitle) {
          if (this.$route.params.nr === item) {
            this.showOthers = false
            return Math.floor(i / 4)
          }
          i++
        }
      }
    },
    components: {
      OffCanvas,
      ICP,
      gsxx,
      glry,
      cyry,
      cwxx,
      gdxx,
      lsqk,
      fzjg,
      cxjl,
      zgs,
      qtgs
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  #xxgs
    .tab
      padding 0 $bj 0 $bj
      background-color $color2
      font-size $font_size2
      color $font_color3
      line-height 40px
      overflow hidden
      z-index: 1000;
      position: relative;
      .icon
        margin-left -2px
        height 24px
        width 24px
      a
        margin 0 15px 0 0
        position relative
        word-break: keep-all
        float left
        &:after
          position absolute
          content ' '
          width 0
          height 5px
          left 50%
          top 23px
        &.active
          color $font_color2
          &:after
            background-color $color1
            width 100%
            left 0
            top 30px
            transition left, width 0.5s, 0.5s
    .wrapper
      padding 0 $bj 0 $bj
      color $font_color1
      font-size $font_size3
      p
        margin-top 13px
        margin-bottom 16px
      .margin-b
        margin-bottom 34px
    .zz
      position: relative
      top -20px
      margin-bottom -20px
      .zzc
        position: absolute
        background-color rgba(0, 0, 0, .35)
        z-index 100
        width 100%
        height 100%
        top -13px
        border-bottom 27px solid transparent
        box-sizing content-box
</style>



// WEBPACK FOOTER //
// xxgs.vue?62cba3a6